import './Profile.scss';
import { Upload, Modal, Button, UploadFile, UploadProps } from "antd";
import { RoleTypeMap } from "../..";
import { UploadImageProfile } from "../../../controllers/store/actions/profile/upload-image-profile-actions";
import { capitalizeString } from "../../../shared/util";
import { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import store from "../../../controllers/store";

interface Props{
    user : any
}

const getBase64 = (file: any): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file as Blob);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
});

const dispatch = store.dispatch;
const ProfileHeader = (props:Props) => {
    console.log("props", props);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [fileList, setFileList] = useState<UploadFile[]>([
        {
            uid: '-1',
            name: 'image.png',
            status: 'done',
            url: `${props.user.avatar}` ,
        },
    ]);

    const handleCancel = () => setPreviewOpen(false);
    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as any);
        }
        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
    };

    const handleChange: UploadProps['onChange'] = ({ file, fileList: newFileList }) => {
        setFileList(newFileList);
    }

    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Cargar Imagen</div>
        </button>
    )

    return (
        <div className="profile-section">
            <>
                <Upload
                    className="profile-avatar-bordered"
                    listType="picture-circle"
                    fileList={fileList}
                    customRequest={async ({ file, onSuccess, onError }) => {
                        try {
                            await dispatch(UploadImageProfile(file as File, props.user.id));
                            if (onSuccess) onSuccess('Ok');
                        } catch (e: any) {
                            if (onError) {
                                onError(e);
                            }
                        }
                    }}
                    multiple={false}
                    maxCount={1}
                    onPreview={handlePreview}
                    onChange={handleChange}
                >
                    {fileList.length >= 1 ? null : uploadButton}
                </Upload>
                <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                </Modal>
            </>
            <h1 className="profile-heading">{capitalizeString(`${props.user.fullname}`)}</h1>
            <Button size="small" type="primary" color="#ff974d">
                {props.user.role}
            </Button>
        </div>
    );
}

export default ProfileHeader;